import { BillingUnitDto } from '@dhl/mdp-api'
import type { BillingUnit } from '~/modules/billingunits/model'
import { convertToAddressDto } from '~/common/components/addresses'

export const convertToBillingUnitDto = ({
  name,
  description,
  id,
  cccId,
  trackerCodeMin,
  trackerCodeMax,
  trackerCodeLast,
  address,
}: BillingUnit): BillingUnitDto => ({
  name,
  description,
  id,
  cccId,
  trackerCodeMin,
  trackerCodeMax,
  trackerCodeLast,
  ...convertToAddressDto(address),
})
